import { render } from "./subCert.vue?vue&type=template&id=3c94e0e2"
import script from "./subCert.vue?vue&type=script&lang=js"
export * from "./subCert.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__